import React, { useState } from 'react';

function ProductCard({ product }) {
  const [quantity, setQuantity] = useState(product.minAmount || 1);

  const handleQuantityChange = (newQuantity) => {
    const minAmount = product.minAmount || 1;
    const step = Number(product.atfStep) || 1;
    
    if (newQuantity >= minAmount) {
      // Round to nearest step
      const roundedQuantity = Math.round(newQuantity / step) * step;
      setQuantity(roundedQuantity);
    }
  };

  const incrementQuantity = () => {
    const step = Number(product.atfStep) || 1;
    handleQuantityChange(quantity + step);
  };

  const decrementQuantity = () => {
    const step = Number(product.atfStep) || 1;
    const minAmount = product.minAmount || 1;
    if (quantity - step >= minAmount) {
      handleQuantityChange(quantity - step);
    }
  };

  const handleAddToCart = () => {
    // Dispatch custom event to add product to basket
    const event = new CustomEvent('addProductToBasket', { 
      detail: { 
        product: product, 
        quantity: quantity 
      } 
    });
    window.dispatchEvent(event);
  };

  return (
    <div data-container="">
      <div data-container="">
        <img 
          data-image="" 
          className="product-img" 
          src={product.thumbnail || `https://via.placeholder.com/150x150?text=${product.name}`}
          alt={product.name}
        />
      </div>
      <div data-container="" className="details">
        <div data-container="" className="productName">
          <span 
            data-expression="" 
            className="name" 
            title={product.name}
          >
            {product.name}
          </span>
        </div>
        <div data-container="" className="productPriceTag">
          <span data-expression="" className="price">
            {product.regularPrice || 0}
          </span>
          <span 
            data-expression="" 
            className="price-lbl" 
            title={product.atfPriceLbl || '/unidade'}
          >
            {product.atfPriceLbl || '/unidade'}
          </span>
        </div>
        <div data-container="">
          <div data-block="Store.Columns3SmallLeftRight" className="OSBlockWidget" id="l2-13_0-$b3">
            <div data-container="" className="columns-small-left-right">
              <div id="l2-13_0-b3-Column1">
                <button 
                  data-button="" 
                  className="btn" 
                  type="button"
                  onClick={decrementQuantity}
                >
                  <span>−</span>
                </button>
              </div>
              <div id="l2-13_0-b3-Column2">
                <span className="input-number">
                  <input
                    data-input=""
                    className="atf-product-amount OSFillParent"
                    type="number"
                    aria-required="false"
                    pattern="[0-9]+.[0-9]*"
                    min={product.minAmount || 1}
                    step={Number(product.atfStep) || 1}
                    value={quantity}
                    onChange={(e) => handleQuantityChange(parseFloat(e.target.value) || 0)}
                    id="l2-13_0-Input_MinAmount"
                  />
                </span>
              </div>
              <div id="l2-13_0-b3-Column3">
                <button 
                  data-button="" 
                  className="btn" 
                  type="button"
                  onClick={incrementQuantity}
                >
                  <span>+</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button 
        data-button="" 
        className="add_to_cart" 
        type="button"
        onClick={handleAddToCart}
      >
        <span>🛒</span>
        Adicionar
      </button>
    </div>
  );
}

export default ProductCard;

